import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { ISingleIdParams } from '../../../../spacesPlatform/utils/actionParams';
import { ICustomViewActions } from './ICustomViewActions';

export class GetCustomizedViewActionsRequest extends Request<ISingleIdParams, ICustomViewActions> {
  constructor(id: string) {
    super('getCustomizedViewActions', { id: id });
  }
}
